<template>
  <b-row class="d-none d-lg-flex summary">
    <b-col lg="4" class="summary-col">
      <label>
        {{ labels.licenses }}
      </label>
      <span>
        {{ licenses.availableLicenses }}
      </span>
    </b-col>
    <b-col lg="4" class="summary-col">
      <label>
        {{ labels.users }}
      </label>
      <slot name="usersCount">
        <span>
          {{ licenses.activatedUsersCount }}
        </span>
      </slot>
    </b-col>
    <b-col
      v-if="!$can('access', 'read-only')"
      lg="4"
      class="summary-col icon-col"
    >
      <b-button
        @click="editLicenses"
        :disabled="isTrialPlan"
        class="mdi mdi-grease-pencil"
      >
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { isBasicPlan, isEnterprisePlan, isTrialPlan } from '@/service/user'

export default {
  created() {
    this.$store.dispatch('company/loadLicenses')
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
      licenses: 'company/licenses',
    }),
    labels() {
      return this.resources.component.licensesSummary
    },
    isTrialPlan() {
      return isTrialPlan()
    },
  },
  methods: {
    refreshLicenses() {
      this.$store.dispatch('company/loadLicenses')
    },
    editLicenses() {
      if (isBasicPlan()) {
        this.$router.push({
          name: 'account.licenses',
          params: { period: 'monthly' },
        })
      } else if (isEnterprisePlan()) {
        this.$router.push({
          name: 'account.details',
          query: { updateLicenses: true },
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.summary {
  @import '~@/styles/custom/colors';

  background-color: map-get($theme-colors, 'denary');
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
  border-right: none;
  border: 1px solid map-get($theme-colors, 'gray07');
  float: right;
  height: 67px;
  padding: 0 0 0 15px;
  width: 283px;

  .summary-col {
    padding: 13px 0 11px 0;

    &:nth-of-type(2) {
      border-left: 1px solid map-get($theme-colors, 'gray00');
      border-right: 1px solid map-get($theme-colors, 'gray00');
    }
  }

  span,
  label {
    display: block;
  }

  label {
    text-transform: uppercase;
    color: map-get($theme-colors, 'gray03');
    font-size: 12px;
    margin: 0;
    text-align: center;
    font-weight: 500;
  }

  span {
    color: map-get($theme-colors, 'primary');
    font-size: 18px;
    text-align: center;
  }

  .icon-col {
    text-align: center;
    padding-top: 8px;
    .mdi {
      background-color: transparent;
      border-color: transparent;
      color: map-get($theme-colors, 'septenary');
      font-size: 20px;

      &:disabled {
        opacity: 0.2;
      }
    }
  }
}
</style>
